/* SATIQ : validation des formulaires + anti-spam sans service tiers ni captcha.
   Trois barrières : champ leurre invisible aux humains, délai minimal de remplissage,
   et jeton de session posé en JavaScript (les robots sans JS ne le remplissent pas). */
(function () {
  'use strict';
  var MIN_MS = 2500;
  var EMAIL = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;

  function msgEl(input) {
    var id = 'err-' + (input.name || 'champ').replace(/[^a-z]+/gi, '-');
    var el = input.parentNode.querySelector('[data-sat-msg="' + id + '"]');
    if (!el) {
      el = document.createElement('p');
      el.setAttribute('data-sat-msg', id);
      el.id = id;
      el.setAttribute('role', 'alert');
      el.style.cssText = 'font-size:12.5px;color:#9E2F1E;line-height:1.5;margin:6px 0 10px;';
      input.parentNode.insertBefore(el, input.nextSibling);
    }
    return el;
  }

  function label(input) {
    if (input.type === 'email') return 'Cette adresse e-mail ne semble pas valide. Vérifiez la partie après le @.';
    if (input.tagName === 'TEXTAREA') return 'Écrivez-nous quelques mots, au moins une phrase.';
    if (input.type === 'tel') return 'Ce numéro ne semble pas valide.';
    return 'Ce champ est nécessaire pour vous répondre.';
  }

  function validate(input) {
    var v = (input.value || '').trim();
    var ok = true;
    if (input.required && !v) ok = false;
    else if (input.type === 'email' && v && !EMAIL.test(v)) ok = false;
    else if (input.tagName === 'TEXTAREA' && input.required && v.length < 10) ok = false;
    var el = msgEl(input);
    el.textContent = ok ? '' : label(input);
    input.setAttribute('aria-invalid', ok ? 'false' : 'true');
    if (ok) { input.removeAttribute('aria-describedby'); input.style.borderColor = ''; }
    else { input.setAttribute('aria-describedby', el.id); input.style.borderColor = '#9E2F1E'; }
    return ok;
  }

  function harden(form) {
    if (form.hasAttribute('data-sat-ready')) return;
    form.setAttribute('data-sat-ready', '');
    form.setAttribute('novalidate', '');

    /* champ leurre : hors écran, non focalisable, ignoré des lecteurs d'écran */
    var trap = document.createElement('div');
    trap.setAttribute('aria-hidden', 'true');
    trap.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden;';
    trap.innerHTML = '<label>Ne pas remplir<input type="text" name="satiq_trap" tabindex="-1" autocomplete="off" value=""></label>';
    form.appendChild(trap);

    var stamp = document.createElement('input');
    stamp.type = 'hidden';
    stamp.name = 'satiq_ts';
    stamp.value = String(Date.now());
    form.appendChild(stamp);

    form.querySelectorAll('input, textarea, select').forEach(function (i) {
      if (i.name === 'satiq_trap' || i.type === 'hidden') return;
      i.addEventListener('blur', function () { validate(i); });
      i.addEventListener('input', function () { if (i.getAttribute('aria-invalid') === 'true') validate(i); });
    });

    form.addEventListener('submit', function (e) {
      var honey = form.querySelector('[name="satiq_trap"]');
      var elapsed = Date.now() - parseInt(stamp.value, 10);
      if ((honey && honey.value) || elapsed < MIN_MS) {
        e.preventDefault();
        var warn = form.querySelector('[data-sat-warn]');
        if (!warn) {
          warn = document.createElement('p');
          warn.setAttribute('data-sat-warn', '');
          warn.setAttribute('role', 'alert');
          warn.style.cssText = 'font-size:13px;color:#9E2F1E;line-height:1.6;margin:14px 0 0;';
          form.appendChild(warn);
        }
        warn.textContent = elapsed < MIN_MS
          ? 'Prenez un instant de plus, puis renvoyez : nous avons besoin de vérifier que vous n\u2019êtes pas un robot.'
          : 'Ce message n\u2019a pas pu être envoyé. Rechargez la page et réessayez dans un instant.';
        return;
      }
      var bad = null;
      form.querySelectorAll('input, textarea').forEach(function (i) {
        if (i.name === 'satiq_trap' || i.type === 'hidden') return;
        if (!validate(i) && !bad) bad = i;
      });
      if (bad) { e.preventDefault(); bad.focus(); }
      else {
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; btn.style.opacity = '0.65'; btn.dataset.satLabel = btn.textContent; btn.textContent = 'Envoi…'; }
      }
    });
  }

  function init() { document.querySelectorAll('#satContactForm, #satWaitlistForm, form[action*="/contact"], form[data-sat-form]').forEach(harden); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
